<template>
  <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(salvarSuspensao)">
      <b-overlay :show="screenBlocked">
        <b-card header-tag="header" class="m-3" no-body>
          <template #header>
            <h6 class="mb-0 text-center">
              <span class="titulo-sagres font-weight-bold">Suspender Impedimento</span>
              <btn-voltar />
              <b-button v-if="temSuspensao ? false : true" class="float-right m-1" size="sm" type="submit">
                <font-awesome-icon icon="save" />
                Salvar
              </b-button>
              <b-button v-if="temSuspensao ? true : false" class="float-right m-1" size="sm"
                @click="perguntarExcluirSuspensao()">
                <font-awesome-icon icon="trash" /> Excluir Suspensão
              </b-button>
            </h6>
          </template>
          <b-card-body>
            <h6 class="mb-0 text-left font-weight-bold">Dados do Impedimento</h6>
            <br />
            <b-row>
              <b-col cols="12" md="3">
                <b-form-group label-size="md" label="CPF / CNPJ">
                  <b-form-input readonly :disabled="true" v-model="impedimento.NrCpfcnpj">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label-size="md" label="Nome">
                  <b-form-input readonly :disabled="true" v-model="impedimento.NmNome">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group label-size="md" label="Protocolo TCE/SE">
                  <b-form-input readonly :disabled="true" v-model="impedimento.deAnoNroProtocolo">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <br>
            <hr><br>
            <h6 class="mb-0 text-left font-weight-bold">Dados da Suspensão</h6>
            <br />

            <b-row>
              <b-col cols="12" md="3">
                <default-form-validation-provider label="Data" v-slot="defState">
                  <b-form-datepicker id="date-dt-suspensao" :readonly="temSuspensao"
                    v-model="impedimento.suspensao.DtSuspensao" :state="defState.state" v-bind="datePickerProps">
                  </b-form-datepicker>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" md="3">
                <b-row class="d-flex align-items-start">
                  <b-col cols="6">
                    <default-form-validation-provider label="Número Protocolo" v-slot="defState" rules="required|min:6|max:6">
                      <b-form-input id="input-nr-protocolo" :readonly="temSuspensao"
                        v-model="impedimento.suspensao.NrProtocoloSuspensao" type="number" @blur="zeroPadNrProtocolo"
                        :state="defState.state">
                      </b-form-input>
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="1" class="d-flex justify-content-center align-items-center mt-4 pt-2">
                    <span class="h3">/</span>
                  </b-col>
                  <b-col cols="5">
                    <default-form-validation-provider label="Ano Protocolo" v-slot="defState" rules="required|min:4|max:4">
                      <b-form-input id="input-ano-protocolo" :readonly="temSuspensao"
                        v-model="impedimento.suspensao.NrAnoprotocoloSuspensao" type="number" :state="defState.state">
                      </b-form-input>
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <!-- vide exemplo em EditarDadosIniciaisLicitacao.vue -->
              <b-col cols="12" md="6">
                <b-form-group id="input-group-arquivo" label-size="md" label="Arquivo texto da suspensão (PDF)">
                  <div v-if="impedimento.arquivoSuspensao">
                    <span>Nome: {{ impedimento.arquivoSuspensao.NmArquivo
                    }}</span>
                    <div class="d-flex justify-content-center">
                      <btn-download class="mr-2" :fazerDownload="() => baixarAnexo(impedimento.arquivoSuspensao.NmArquivo)" />
                      <b-link class="text-dark" @click="removerAnexo()">
                        <font-awesome-icon icon="times" />
                        <div style="font-size: 12px">Remover</div>
                      </b-link>
                    </div>
                  </div>
                  <div v-else>
                    <default-form-validation-provider noLabel v-slot="defState">
                      <b-form-file v-model="impedimento.arquivo" :state="defState.state"
                        placeholder="Nenhum arquivo selecionado" accept="application/pdf">
                      </b-form-file>
                    </default-form-validation-provider>
                  </div>

                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component, Ref } from "vue-property-decorator";
import impedidosService from "@/services/contratacao/impedidosService"
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { Impedimentos } from "@/types/contratacao/impedimentos";
import { DatePickerDefaultProps } from '@/types/form-default-props'
import btnDownload from "@/components/shared/btn-download.vue";
import { Suspensao } from "@/types/contratacao/suspensao";
const CompProps = Vue.extend({
  name: "SuspenderImpedimento",
  components: {
    BtnVoltar,
    btnDownload,
    DefaultFormValidationProvider,
    ValidationObserver,
  },
  props: {
    idImpedimento: {
      type: String,
      required: true
    }
  }
});

type ValidationStateParams = {
  dirty: boolean;
  validated: boolean;
  valid: boolean | null;
};

@Component
export default class SuspenderImpedimento extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  impedimento = new Impedimentos()
  novaSuspensao = new Suspensao()
  screenBlocked = false;
  temSuspensao = false;
  datePickerProps = DatePickerDefaultProps;


  async created() {

    try {
      this.screenBlocked = true
      if (this.idImpedimento.length > 0) {
        this.impedimento = await impedidosService.getImpedimentoId(this.idImpedimento)
        if (this.impedimento.suspensao.FlAtivo === true) {
          this.temSuspensao = true;
        }


      }

    }
    catch (e: any) {
      console.error('Erro ao receber dados do impedimento', e)
    }
    finally {
      this.screenBlocked = false
    }
  }

  async salvarSuspensao(): Promise<void> {
    try {
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
        return;
      }

      this.screenBlocked = true;
      const response = await impedidosService.salvarSuspensao(this.idImpedimento, this.impedimento);
      if (response && response.status == 200) {
        this.$toast.success(`Suspensão salva com sucesso!`);
        this.$router.push("/contratacao/impedidos-de-contratar");
      } else {
        this.$toast.error(
          response.data.msg || "Erro ao salvar suspensão."
        );
      }
    } catch (e: unknown) {
      console.error("Erro ao salvar suspensão", e, this.impedimento);
      if (e instanceof Error) {
        this.$toast.error(e.message);
      } else {
        this.$toast.error("Erro ao salvar suspensão.");
      }
    } finally {
      this.screenBlocked = false;
    }
  }

  zeroPadNrProtocolo(event) {
    const input = event.target;
    if (input.value.length === 0) return;

    this.impedimento.suspensao.NrProtocoloSuspensao = this.padZeros(
      +this.impedimento.suspensao.NrProtocoloSuspensao,
      6
    );
  }

  perguntarExcluirSuspensao() {
    this.$bvModal.msgBoxConfirm('Tem certeza que deseja excluir a suspensão?', {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Excluir',
      title: 'Confirmar exclusão',
    }).then(value => {
      if (value) this.excluirSuspensao()
    }).catch(err => {
      console.error('Erro ao excluir suspensão', err)
    })
  }


  async baixarAnexo(nomeArquivo: string) {
    try {
      const response = await impedidosService.baixarAnexoSuspensao(this.impedimento.IdImpedimento)
      this.download(nomeArquivo || `arquivo-suspensao-${this.impedimento.IdImpedimento}`, response.data)
    } catch (e: any) {
      this.tratarError(e)
    }
  }

  removerAnexo() {
    this.impedimento.arquivoSuspensao = undefined
  }

  async excluirSuspensao(): Promise<void> {
    try {
      const response = await impedidosService.excluirSuspensao(this.idImpedimento, this.impedimento)
      if (response && response.status == 200) {
        this.$toast.success('Suspensão excluida com sucesso');
        this.$router.push("/contratacao/impedidos-de-contratar");
      } else {
        this.$toast.error(
          response.data.msg || "Erro ao excluir suspensão."
        );
      }
    } catch (e: any) {
      console.error("Erro ao excluir suspensão", e, this.impedimento);
      if (e instanceof Error) {
        this.$toast.error(e.message);
      } else {
        this.$toast.error("Erro ao excluir suspensão.");
      }
    }
  }

}

</script>

<style></style>